<template>
  <div class="home">
    <div class="top" :style="{ backgroundImage: 'url(' + bg + ')' }">
      <div class="a xy-center text-center bold">
        <div>
          <div class="t" style="font-size: 72px">创造灵感，传递文化</div>
          <div style="font-size: 20px">广州市大鲲文化传媒有限公司</div>
        </div>
      </div>
      <div class="qc xy-center text-center">
        <div style="margin-right: 50px">
          <img :src="qc1" style="width: 150px; height: 150px" />
          <div>抖音扫一扫</div>
        </div>
        <div>
          <img :src="qc2" style="width: 150px; height: 150px" />
          <div>微信扫一扫</div>
        </div>
      </div>
    </div>
    <div class="grid-2 bg-white grid-gap-30" style="padding: 140px 30px">
      <div class="xy-center"><img :src="b1" style="width: 100%" /></div>
      <div style="padding-top: 50px">
        <div class="bold h1">
          ABOUT US
          <div class="a">关于我们</div>
        </div>
        <div class="tt" style="padding: 50px 10px">
          广州市大鲲文化传媒有限公司是一家集文化传媒、艺术设计、活动策划、品牌营销、娱乐演艺于一体的综合型公司。<br />
          公司以“创新、专业、务实、品质”为宗旨，以“树立品牌形象，打造文化精品，推进文化创意产业发展”为主旨，致力于为客户提供全面、专业的文化传媒服务。拥有一支高素质的团队，结合全球前沿的视觉艺术、时尚设计和当代文化，为客户提供充满创造力的设计方案和创意策划。<br />
          公司秉承“诚信、服务、共赢”的经营理念，以丰富的行业经验和出色的团队实力完成了众多重要项目的设计、策划和执行，赢得了广泛的赞誉和信任。公司业务覆盖了多个领域和行业，包括企业品牌形象策划、展览展示设计、活动策划执行、娱乐演艺、数字营销等。<br />
          大鲲文化传媒，立足广州市，放眼全球，是您成就文化梦想的理想合作伙伴。
        </div>
      </div>
    </div>
    <div style="padding: 80px 10px">
      <div class="xy-center">
        <div class="text-center">
          <div class="h2">
            TEAM
            <div class="a1">我们的团队</div>
            <div class="a2"></div>
          </div>
        </div>
      </div>
      <div class="grid-3 grid-gap-30">
        <div
          class="bg-white card"
          style="padding: 20px; border-radius: 10px"
          v-for="(item, i) in list"
          :key="i"
        >
          <div class="xy-center">
            <img :src="item.img" style="height: 220px" />
          </div>
          <div class="t2">
            {{ item.title }}
            <div class="b"></div>
          </div>
          <div class="t3">{{ item.p }}</div>
        </div>
      </div>
    </div>
    <div style="background: rgba(15, 25, 58, 1); color: #fff">
      <div class="xy-center">
        <div
          class="y-center b"
          style="
            width: 100%;
            min-width: 768px;
            max-width: 1200px;
            padding: 40px 0;
            border-bottom: 1px solid #999;
          "
        >
          <!-- <div
            class="bg-white"
            style="font-size: 0; border-radius: 6px; width: 100px; height: 100px"
          >
            <img :src="logo" alt="" style="width: 100%" />
          </div>
          <div
            class="bg-white"
            style="
              font-size: 0;
              border-radius: 6px;
              width: 100px;
              height: 100px;
              overflow: hidden;
              margin: 0 20px;
            "
          >
            <img :src="qr" alt="" style="width: 100px; padding-top: 5px" />
          </div> -->
          <div>
            <div style="padding-bottom: 30px">公司名称：广州市大鲲文化传媒有限公司</div>
            <div>公司地址：广州市天河区荔苑路18号B栋C2159</div>
          </div>
        </div>
      </div>
      <div class="text-center" style="font-size: 12px; padding: 20px">
        COPYRIGHT © 大鲲文化gz-dakun.top 广州市大鲲文化传媒有限公司 版权所有
        <a
          href="https://beian.miit.gov.cn/"
          style="color: #96bbf7; text-decoration: none"
          target="_blank"
          >粤ICP备2023075723号-1</a
        >
      </div>
    </div>
    <div style="width: 300px; margin: 0 auto; padding: 20px 0">
      <a
        target="_blank"
        href=" "
        style="display: inline-block; text-decoration: none; height: 20px; line-height: 20px"
      >
        <img :src="ba" style="float: left" />
        <p
          style="
            float: left;
            height: 20px;
            line-height: 20px;
            margin: 0px 0px 0px 5px;
            color: #939393;
          "
        >
          粤公网安备 44010602011734号
        </p>
      </a>
    </div>
  </div>
</template>

<script>
import bg from '@/assets/bg.png'
import b1 from '@/assets/b1.png'
import b2 from '@/assets/b2.png'
import b3 from '@/assets/b3.png'
import b4 from '@/assets/b4.png'
// import logo from '@/assets/logo.png'
// import qr from '@/assets/qr.png'
import ba from '@/assets/ba.jpg'
import qc1 from '@/assets/qc1.png'
import qc2 from '@/assets/qc2.png'
export default {
  name: 'HomeView',
  data() {
    return {
      bg,
      b1,
      // logo,
      // qr,
      qc1,
      qc2,
      ba,
      list: [
        {
          title: '创意性强',
          p: '文化传媒公司的团队通常由具有创造力和想象力的人才组成，他们常常能够看到别人看不到的创意点，并能够把这些点变成创意方案和创新产品。',
          img: b2
        },
        {
          title: '多元化',
          p: '文化传媒公司的团队成员通常具有不同的专业背景和技能，他们以不同的视角看待和处理问题，能够提供解决问题的多元化方案。',
          img: b3
        },
        {
          title: '团队合作能力强',
          p: '文化传媒公司的团队成员通常都有较强的团体意识和协作能力，他们能够相互合作完成任务，发挥各自的优势，整合资源，从而提供客户最好的解决方案。',
          img: b4
        }
      ]
    }
  }
}
</script>

<style lang="scss">
.home {
  .top {
    height: 100vh;
    width: 100%;
    min-width: 768px;
    background-position: center center;
    background-size: cover;
    background-repeat: no-repeat;
    position: relative;
    .qc {
      position: absolute;
      z-index: 555;
      right: 40px;
      top: 40px;
      color: #fff;
    }
    .a {
      position: absolute;
      width: 100%;
      min-width: 768px;
      height: 100%;
      left: 0;
      top: 0;
      background-color: rgba($color: #000000, $alpha: 0.5);
      color: #fff;
      .t {
        padding: 30px 60px;
        border: 1px solid #fff;
        margin-bottom: 50px;
      }
    }
  }
  .h1 {
    font-weight: 700;
    font-size: 100px;
    color: rgba(215, 215, 215, 0.2784313725490196);
    padding-left: 120px;
    padding-bottom: 10px;
    position: relative;
    border-bottom: 4px solid rgba(215, 215, 215, 0.2784313725490196);
    .a {
      font-size: 42px;
      color: #333333;
      position: absolute;
      bottom: -4px;
      padding-bottom: 10px;
      left: 0;
      border-bottom: 5px solid #1fe2ca;
    }
  }
  .inline-block {
    display: inline-block;
    background-color: #1fe2ca;
    width: 90%;
    height: 4px;
  }
  .h2 {
    font-weight: 700;
    font-size: 72px;
    color: rgba(215, 215, 215, 0.2784313725490196);
    position: relative;
    .a1 {
      position: absolute;
      top: -30px;
      font-size: 42px;
      font-weight: 700;
      color: #333;
      white-space: nowrap;
      z-index: 10;
    }
    .a2 {
      position: absolute;
      top: 10px;
      z-index: 8;
      width: 80%;
      left: 10%;
      height: 10px;
      background-color: #1fe2ca;
    }
  }
}
.tt {
  font-size: 24px;
  line-height: 44px;
}
.bold {
  font-weight: bold;
}
.text-center {
  text-align: center;
}
.flex {
  display: flex;
}
.flex-1 {
  flex: 1;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.items-center {
  align-items: center;
}
.xy-center {
  @extend .flex;
  @extend .justify-center;
  @extend .items-center;
}
.y-center {
  @extend .flex;
  @extend .items-center;
}
.grid-2 {
  display: grid;
  grid-template-columns: 1fr 1fr;
}
.card {
  margin-top: 30px;
  &:hover {
    transform: scale(1.02);
    transition-duration: 0.3s;
  }
}
.grid-3 {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  .t2 {
    padding: 10px 0;
    margin: 30px 20px;
    font-weight: bold;
    color: #333333;
    font-size: 20px;
    border-bottom: 1px solid #ddd;
    position: relative;
    &:hover {
      color: #1fe2ca;
    }
    .b {
      position: absolute;
      width: 120px;
      left: 0;
      height: 3px;
      background-color: #1fe2ca;
      bottom: -2px;
    }
  }
  .t3 {
    padding: 0 20px;
    line-height: 30px;
  }
}

.grid-gap-30 {
  grid-gap: 30px;
}
.bg-white {
  background-color: #fff;
}
</style>
